import React from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';

import * as actionCreators from 'store/actions'
import { accessContext } from 'context'

const Container = styled.div`
    display: flex;
    flex-direction: column;
    margin: 0 1rem 0 0;
    width: 100%;
    padding: 0.5rem;
    border-radius: 5px;
    background-color: var(--secondary-color);
    box-shadow: var(--box-shadow);
`

const GridContainer = styled.div`
    display: grid;
    /* grid-template-columns: repeat(2, calc(50% - 0.25rem)); */
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-template-rows: auto auto;
    grid-column-gap: 0.5rem;
    /* grid-row-gap: 0.5rem; */
`

const Title = styled.div`
    font-weight: bolder;
    font-size: 0.7rem;
    padding: 0 0 0.25rem 0;
    text-transform: uppercase;
    color: var(--secondary-accent-color);
    display: flex;
    align-items: center;
    justify-content: center;
`

const Tile = styled.div`
    /* width: 3rem;
    height: 3rem; */
    /* color: var(--secondary-accent-color); */
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0.5rem 0.5rem;
    /* color: ${props => props.selected ? 'var(--focus-color)' : 'var(--text-color)'}; */
    border: ${props => `2px solid ${props.selected ? 'var(--focus-color)' : 'var(--primary-accent-color)'}`};
    background-color: var(--secondary-color);
    border-radius: 5px;
    cursor: pointer;
    :hover{
        filter: brightness(var(--brightness));
    }
`

const Icon = styled.div`
    font-size: 1.2rem;
    margin-bottom: 0.2rem;
`

const Label = styled.div`
    font-size: 0.8rem;
`



const AccessOptions = props => {
    const {
        closeHandler
    } = props;
    const dispatch = useDispatch();
    const showAccess = useSelector(state => state.content.showAccess)
    const accessModule = useSelector(state => state.content.access)
    const activeModules = _.filter(accessContext, { active: true })

    const onSelect = (module) => {
        closeHandler && closeHandler()
        dispatch(actionCreators.setAccess(true, module, module === 'CALENDAR' ? { range: 'day' } : {}))
    }

    let blocks = []
    for (const [key, module] of Object.entries(activeModules)) {
        blocks.push(
            <Tile onClick={() => onSelect(module['value'])} selected={showAccess && module['value'] === accessModule}>
                <Icon>{module['icon']}</Icon>
                <Label>{module['title']}</Label>
            </Tile>
        )
    }      
    
    return (
        <Container>
            <Title>Modules</Title>
            <GridContainer>{blocks}</GridContainer>
        </Container>
    )
}

export default AccessOptions